// test1282
(1282 && 0);
